import React from "react";
import { features } from "../data";

const epkChecks = [
  "AI-generated biography",
  "Shareable profile — musicuntamed.com/artist/you",
  "Download as PDF",
  "Media-ready presentation"
];

function CheckIcon() {
  return (
    <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
      <path d="M13.485 1.431a1.5 1.5 0 0 1 .084 2.118l-7.5 8.25a1.5 1.5 0 0 1-2.15.048l-3.75-3.75a1.5 1.5 0 1 1 2.122-2.122l2.628 2.628 6.447-7.088a1.5 1.5 0 0 1 2.119-.084Z" />
    </svg>
  );
}

export default function WhyChoose() {
  return (
    <section className="mu-section">
      <div className="container">
        <div className="mb-4">
          <div className="mu-eyebrow">The Platform</div>
          <h2 className="section-title">Why Choose MusicUntamed?</h2>
          <p className="section-sub">Built for artists. Loved by fans. Designed to help music thrive.</p>
        </div>

        <div className="row g-4 mb-5">
          {features.map((f, i) => (
            <div className="col-md-6 col-lg-4" key={i}>
              <div className="feature-card">
                <div className="feature-icon"></div>
                <h6>{f.title}</h6>
                <p>{f.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="epk-banner" id="epk">
          <div className="row align-items-center g-4">
            <div className="col-lg-7">
              <div className="mu-eyebrow on-purple">Sonique EPK Generator</div>
              <h3 className="fw-bold mb-3" style={{ fontSize: "1.7rem" }}>
                Build Your Professional Artist Profile with AI
              </h3>
              <p style={{ color: "#dccdf2", fontSize: ".92rem", maxWidth: "480px" }}>
                Generate a polished Electronic Press Kit in minutes. Showcase your biography,
                music, achievements, media assets, and social links — all from one personalized
                profile you can share anywhere.
              </p>
              <div className="mt-3 mb-4">
                {epkChecks.map((c, i) => (
                  <div className="epk-check" key={i}>
                    <CheckIcon />
                    {c}
                  </div>
                ))}
              </div>
              <a href="#epk" className="btn-mu-outline-light">Create Your AI EPK &rarr;</a>
            </div>
            <div className="col-lg-5">
              <div className="epk-mock">
                <div className="epk-url">musicuntamed.com/artist/burna-boy</div>
                <div className="d-flex align-items-center gap-3">
                  <div className="epk-mock-avatar">
                    <img src="https://picsum.photos/seed/mu-epk-avatar/120/120" alt="Artist avatar" />
                  </div>
                  <div className="flex-grow-1">
                    <div className="epk-mock-line" style={{ width: "70%" }}></div>
                    <div className="epk-mock-line" style={{ width: "45%" }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
